import {
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Output,
  inject,
} from '@angular/core';
import { MatInput } from '@angular/material/input';
import { Numbers } from '../utils/numbers';

@Directive({ selector: '[appRestrictPercentDecimalPoint]' })
export class RestrictPercentDecimalPointDirective {
  private readonly el = inject<ElementRef<MatInput>>(ElementRef);

  @Output() public numericValue = new EventEmitter<string>();
  private readonly regex = new RegExp(/^\d*\.?\d{0,2}/);
  private readonly specialKeys: string[] = ['Backspace', 'Tab', 'End', 'Home', 'Ctrl', 'v', 'ArrowLeft', 'ArrowRight'];
  @HostListener('input', ['$event'])
  public onKeyDown(event: KeyboardEvent): void {
    // Allow Backspace, tab, end, and home keys
    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }
    let inputValue = this.el.nativeElement.value;
    if (!inputValue.includes('%')) {
      // remove the value before the % instead of removing just the %
      inputValue = inputValue.slice(0, inputValue.length - 1);
    }
    const current = String(Numbers.convertFromPercentToString(inputValue));
    const match: RegExpMatchArray = current.match(this.regex);

    let value = match[0] || '';

    value = `${value}%`;
    this.el.nativeElement.value = value;
    this.numericValue.emit(value);
  }
}
